import React from "react"

type Props = {
  className?: string
}

export const OrderIcon = ({ className }: Props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M7.99854 16.0017H13.0006"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.8767 16.1267C15.9457 16.1267 16.0017 16.0707 16.0017 16.0017C16.0017 15.9326 15.9457 15.8766 15.8767 15.8766C15.8076 15.8766 15.7516 15.9326 15.7516 16.0017C15.7516 16.0707 15.8076 16.1267 15.8767 16.1267"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.99854 12H13.0006"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.99658 4.49665V19.5034C3.99658 19.8503 4.17612 20.1725 4.47132 20.3548C4.76652 20.5371 5.13508 20.5533 5.44519 20.3978L6.21651 20.0116C6.49795 19.8706 6.82944 19.8706 7.11088 20.0116L8.88462 20.898C9.16606 21.039 9.49755 21.039 9.77899 20.898L11.5527 20.0116C11.8342 19.8706 12.1657 19.8706 12.4471 20.0116L14.2208 20.898C14.5026 21.039 14.8344 21.039 15.1162 20.898L16.888 20.0116C17.1697 19.8706 17.5015 19.8706 17.7833 20.0116L18.5556 20.3978C18.8657 20.553 19.2339 20.5365 19.5289 20.3543C19.8238 20.1721 20.0032 19.8501 20.0032 19.5034V4.49665C20.0032 4.14972 19.8237 3.82751 19.5285 3.64525C19.2333 3.46299 18.8647 3.44673 18.5546 3.60228L17.7833 3.98844C17.5019 4.1295 17.1704 4.1295 16.889 3.98844L15.1152 3.10207C14.8338 2.96101 14.5023 2.96101 14.2208 3.10207L12.4471 3.98844C12.1658 4.1285 11.8351 4.1285 11.5537 3.98844L9.77999 3.10207C9.4982 2.96101 9.16641 2.96101 8.88462 3.10207L7.11288 3.98844C6.83109 4.1295 6.4993 4.1295 6.21751 3.98844L5.44419 3.60228C5.13417 3.44708 4.7659 3.46354 4.47096 3.64576C4.17602 3.82798 3.99658 4.14996 3.99658 4.49665Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.8767 12.1251C15.9457 12.1251 16.0017 12.0691 16.0017 12C16.0017 11.931 15.9457 11.875 15.8767 11.875C15.8076 11.875 15.7516 11.931 15.7516 12C15.7516 12.0691 15.8076 12.1251 15.8767 12.1251"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.99854 7.99832H13.0006"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.8767 8.12337C15.9457 8.12337 16.0017 8.06738 16.0017 7.99832C16.0017 7.92925 15.9457 7.87326 15.8767 7.87326C15.8076 7.87326 15.7516 7.92925 15.7516 7.99832C15.7516 8.06738 15.8076 8.12337 15.8767 8.12337"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
